module.exports = __webpack_public_path__ + "static/media/deleteCartProduct.946081ac.svg";